import { useEffect, useRef } from 'react';
export const useFramePortalContainer = rootNode => {
  const containerRef = useRef(null);
  useEffect(() => {
    // Create div and append to body
    const div = rootNode || document.createElement('div');
    document.body.appendChild(div);
    containerRef.current = div;

    // Cleanup function to remove div from body
    return () => {
      if (containerRef.current && document.body.contains(containerRef.current)) {
        document.body.removeChild(containerRef.current);
      }
    };
  }, [rootNode]);
  return containerRef;
};